module.exports = __webpack_public_path__ + "static/media/wrong.35daf8b0.png";